import { css } from 'lit';
export default css `
  wui-flex {
    width: 100%;
    background-color: var(--wui-color-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;
//# sourceMappingURL=styles.js.map